module.exports = __webpack_public_path__ + "img/jiagou.ca7f74f1.png";